import { getBackendUrl } from "@Utils";
import { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid } from "recharts";
import axiosWrapper from "../../services/axiosWrapper";
import NoPortalDataIllustration from "./NoPortalData";
import { useTranslation } from "react-i18next";

function TasksStatusGraphTile({ projectId }) {
  const [graphTasksDataByStatus, setGraphTasksDataByStatus] = useState({});
  const { t } = useTranslation();
  const init = async () => {
    const statusResponse = await axiosWrapper.get(`${getBackendUrl()}/tasks/getAllStatusesForTasks`);
    const tasksStatusData = {};
    await Promise.all(
      statusResponse.data.data.map(async (data) => {
        const params = {
          value: {
            requiresCounts: true,
            projectId,
            where: [
              {
                field: "status",
                operator: "equal",
                value: data.id,
              },
            ],
            take: 0,
          },
        };
        const tasksResponse = await axiosWrapper.post(`${getBackendUrl()}/tasks/tasksController`, params);
        tasksStatusData[data.name] = tasksResponse.data.count;
      }),
    );
    setGraphTasksDataByStatus(tasksStatusData);
  };

  useEffect(() => {
    init();
  }, [projectId]);

  const COLORS = ["#ffb573", "#e75555", "#2c80ff"];

  return Object.values(graphTasksDataByStatus).filter((a) => a > 0).length > 0 ? (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={[
          { Status: "Pending", Tasks: graphTasksDataByStatus.OPEN },
          {
            Status: "In Progress",
            Tasks: graphTasksDataByStatus.IN_REVIEW,
          },
          { Status: "Completed", Tasks: graphTasksDataByStatus.CLOSED },
        ]}
        margin={{
          top: 20,
          right: 25,
          left: -5,
        }}
      >
        <CartesianGrid strokeDasharray="3 0" vertical={false} stroke="var(--primary-blue)" />
        <XAxis dataKey="Status" stroke="var(--primary-blue)" tickLine={false} tick={{ fill: "#666a84" }} />
        <YAxis stroke="var(--primary-blue)" tickLine={false} tickMargin={10} tick={{ fill: "#666a84" }} />
        <Bar dataKey="Tasks" stackId="a" barSize={60}>
          {Object.keys(graphTasksDataByStatus).map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  ) : (
    <NoPortalDataIllustration name={t("Tasks")} />
  );
}

export default TasksStatusGraphTile;
